import { $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'
import { ListComponent } from './list'

const LIST_SELECTOR = 'list-component'

export class ListBtn extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'keydown', this.handleKeyDown)
    this.addListener(this, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()
      this.update()
    }
  }

  update(): void {
    const list: ListComponent = $elParent(LIST_SELECTOR, this)

    if (this.dataset.trigger === 'collapse') {
      list?.collapse()
    } else {
      list?.expand()
    }
  }
}
